<template>
  <div class="col-sm-3 align-self-center text-center mt-4" >
      <slot></slot>
  </div>
</template>

<script>
export default {
    name:"choiceToggle",
    props: ['item'],
    data(){
    return {
        isActive: false
    }
    },
    methods: {
    toggleClass() {
        this.isActive = !this.isActive;
    }
    }
}
</script>

<style scoped>
.active {
    box-shadow: 5px 10px 8px rgba(0, 0, 0, 0.5), 0 6px 20px 0 rgba(0, 0, 0, 0.2);
    border: solid blue 5px;
    border-radius: 50%;
    opacity: 0.7;

}

.activep {
    color: blue;
    font-weight: 900;
}

</style>


// WEBPACK FOOTER //
// src/components/general/choiceToggle.vue